import React, { Component } from 'react';
import CreateBankAccountForm from './CreateBankAccountForm';
import { LogError } from '../../../AppUtil/AppUtil';
import Swal from 'sweetalert2';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { commonStyleForEditPersonalInfo } from '../../Common/CommonStyle';

import BuxService from '../../../Service/BuxService';
import UserService from '../../../Service/UserService';

class index extends Component {
	// NOSONAR
	constructor(props) {
		super(props);
		this.state = {
			_isLoading: false,
			bankOptions: []
		};
	}

	componentDidMount() {
		this.fetchBanks();
	}

	fetchBanks = async () => {
		this.toggleLoader();
		try {
			const response = await BuxService.getBanks();

			if (!response || response.status !== 'success') {
				const msg = response.message || 'Fetch banks request failed';
				throw new Error(msg);
			}

			const banks = [...response['Instapay Banks']];
			const bankOptions = banks.map(d => ({ label: d, value: d }));

			this.setState({
				bankOptions,
				_isLoading: false
			});
		} catch (err) {
			this.toggleLoader();
			LogError(err);
		}
	};

	toggleLoader = () => {
		this.setState({
			_isLoading: !this.state._isLoading
		});
	};

	toastFail = msg => {
		Swal.fire({
			title: 'Error',
			text: msg,
			imageUrl: 'https://cdn-icons-png.flaticon.com/512/5219/5219070.png',
			imageAlt: 'Custom Image',
			// icon: 'error',
			confirmButtonText: 'Try again',
			customClass: 'otp_message_success'
		});
	};

	toaster = msg => {
		Swal.fire({
			title: 'Info',
			text: msg,
			icon: 'info',
			confirmButtonText: 'OK',
			customClass: 'otp_message_success'
		}).then(res => {
			if (res.value) {
				window.location.reload();
			}
		});
	};

	onBankAccountSubmit = async bankAccountData => {
		try {
			const currentUser = this.props.currentUser;

			this.toggleLoader();
			const response = await BuxService.buxCreateBank(bankAccountData);
			if (!response || response.status !== 'success') {
				const msg = response.message || 'Add bank account request failed';
				this.toastFail(msg);
				throw new Error(msg);
			}

			await UserService.updateUserInfo({
				first_name: currentUser.first_name,
				last_name: currentUser.last_name,
				bank_account_id: response.bank_account_id,
				account_number: bankAccountData.account_number,
				bank: bankAccountData.bank
			});

			this.toaster(this.props.t('sweetalert.create_bank_account_info'));

			const updatedCurrentUser = await UserService.updateCurrentUser();
			if (updatedCurrentUser.profile) await this.props.setCurrentUser(updatedCurrentUser);

			this.props.onBack();
			this.toggleLoader();
		} catch (err) {
			this.toggleLoader();
			LogError(err);
		}
	};

	render() {
		const currentUser = this.props.currentUser;
		console.log(currentUser);
		return (
			<CreateBankAccountForm
				bankOptions={this.state.bankOptions}
				closeProfileScreen={this.props.closeProfileScreen}
				isLoading={this.state._isLoading}
				onSubmit={this.onBankAccountSubmit}
				user={this.props.user}
			/>
		);
	}
}

export default withStyles(commonStyleForEditPersonalInfo)(withTranslation()(index));
